import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative inline-flex rounded-md shadow-sm page-email-builder-template__btn-save" }
const _hoisted_2 = {
  key: 0,
  class: "flex absolute h-3 w-3 top-0 right-0 -mt-1 -mr-1"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "animate-ping absolute inline-flex h-full w-full rounded-full bg-curious-blue-500 opacity-75" }, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "relative inline-flex rounded-full h-3 w-3 bg-curious-blue-500" }, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UISpinner = _resolveComponent("UISpinner")!
  const _component_UIButton = _resolveComponent("UIButton")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_UIButton, {
      id: _ctx.id,
      use: "secondary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
      size: "small",
      class: _normalizeClass(["relative ml-4 bg-white text-curious-blue-500 hover:bg-curious-blue-20", _ctx.loading ? 'pointer-events-none' : ''])
    }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_UISpinner, {
              key: 0,
              size: "small",
              color: "#38A0DB",
              class: "absolute top-0",
              style: { left: 'calc(50% - 11px)' }
            }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          class: _normalizeClass({ invisible: _ctx.loading })
        }, _toDisplayString(_ctx.$t(_ctx.label)), 3 /* TEXT, CLASS */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["id", "class"]),
    (_ctx.unsavedChanges)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_5))
      : _createCommentVNode("v-if", true)
  ]))
}